import L from 'leaflet';
import HttpService from './http-service.js';
import Map from './map-singleton';

export default class AddressService {
    constructor(map) {
        this.enable = false;
        this.map = map;
        this.addressLayer = null;
        this.httpService = new HttpService();
        this.path = '../../../';
        this._onAddressClick.bind(this);
    }

    toggleAddress() {
        if (this.enable) {
            this.enable = false;
            this._endAddressDefinition();
        }
        else {
            this.enable = true;
            this._beginAddressDefinition();
        }
    }

    _beginAddressDefinition() {

        this.map.on('click', this._onAddressClick);

        if (this.addressLayer != null) {
            this.map.removeLayer(this.addressLayer);
            this.addressLayer = null;
        }

        this.addressLayer = L.layerGroup();
        this.map.addLayer(this.addressLayer);
        L.DomUtil.addClass(this.map._container, 'leaflet-crosshair');
    }

    _endAddressDefinition() {
        if (this.addressLayer != null && this.map.hasLayer(this.addressLayer)) {
            this.map.removeLayer(this.addressLayer);
        }
        this.addressLayer = null;
        this.map.off('click', this._onAddressClick);
        L.DomUtil.removeClass(this.map._container, 'leaflet-crosshair');
    }

    _onAddressClick = event => {
        this.httpService.getData(`/getaddressext?lat=${event.latlng.lat}&lon=${event.latlng.lng}`)
            .then(
                data => {
                    this._showMarker(event.latlng, data.replace(/"/g, ''));
                },
                error => { }
            );
    }

    _showMarker(latlng, label) {
        var myIcon = L.icon({
            iconUrl: this.path + 'img/flag.png',
            iconAnchor: [8, 8],
            iconSize: [16, 16],
        });

        var m = L.marker(latlng, { icon: myIcon });

        m.bindTooltip(label, { permanent: true, direction: 'right' }).openTooltip();
        this.addressLayer.addLayer(m);
    }
}

